// モジュール呼び出し
import PlayController from '../lib/PlayController';

/**
 * Recommended Placesの背景画像
 */
export default function v1RecommendationHero(elm) {
  const $target = elm;
  const movieParent = document.querySelector('.js-recommendationHero__movie');
  $target.setAttribute('aria-busy', 'true');
  // ロード完了時の挙動
  const actLoadstart = () => {
    movieParent.setAttribute('aria-busy', 'false');
    $target.setAttribute('aria-busy', 'false');
  };
  $target.addEventListener('loadeddata', actLoadstart, false);
  const movieControll = PlayController(
    $target,
    {
      button: document.getElementById('js-recommendationHero__play'),
      callback: target => {
        target.play(); // 再生
      },
    },
    {
      button: document.getElementById('js-recommendationHero__stop'),
      callback: target => {
        target.pause(); // 一時停止
      },
    },
  );
  movieControll.init();
}
